import {Injectable} from '@angular/core';
import {environment} from '@env';
import {Performance, trace, PerformanceTrace} from '@angular/fire/performance';

@Injectable()
export class PerformanceService {
  enabled = true;
  isBrowser: boolean;

  constructor(private performance: Performance) {
    this.enabled = environment.production;
  }

  /**
   * Track an analytical event by the event name and pass in optional parameters like store state for debugging
   * @param traceName
   */
  traceEvent(traceName: string): PerformanceTrace {
    if (this.enabled) {
      return trace(this.performance, traceName);
    }
    return null;
  }
}
